export default "__VITE_ASSET__C4x1PXWR__"